<template>
  <div>
    <div class="keypadwrapper">
      <div>
        <h1 v-if="title != null" class="pb-4">{{ title }}</h1>
        <input class="numberinput" type="text" v-model="number" readonly="readonly" />
      </div>
      <div class="container keypad">
        <div>
          <div id="lineone" class="numberRow">
            <div class="content" @click="numberClick(1)" data-value="1">
              <div>
                <span class="number">1</span>
              </div>
            </div>
            <div class="content" @click="numberClick(2)" data-value="2">
              <div>
                <span class="number">2</span>
              </div>
            </div>
            <div class="content" @click="numberClick(3)" data-value="3">
              <div>
                <span class="number">3</span>
              </div>
            </div>
          </div>
          <div id="linetwo" class="numberRow">
            <div class="content" @click="numberClick(4)" data-value="4">
              <div>
                <span class="number">4</span>
              </div>
            </div>
            <div class="content" @click="numberClick(5)" data-value="5">
              <div>
                <span class="number">5</span>
              </div>
            </div>
            <div class="content" @click="numberClick(6)" data-value="6">
              <div>
                <span class="number">6</span>
              </div>
            </div>
          </div>
          <div id="linethree" class="numberRow">
            <div class="content" @click="numberClick(7)" data-value="7">
              <div>
                <span class="number">7</span>
              </div>
            </div>
            <div class="content" @click="numberClick(8)" data-value="8">
              <div>
                <span class="number">8</span>
              </div>
            </div>
            <div class="content" @click="numberClick(9)" data-value="9">
              <div>
                <span class="number">9</span>
              </div>
            </div>
          </div>
          <div id="linefour" class="numberRow">
            <div class="content" @click="numberClick(0)" data-value="0">
              <div>
                <span class="number">0</span>
              </div>
            </div>
            <div class="content" @click="numberClick('<')" data-value="<">
              <div class="delete-btn">
                <span class="number">{{ getMessage('BTN_BORRAR') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="buttonpad">
        <button :class="isDisabled ? 'btn-secondary-disabled' : 'btn-primary'" @click="acept()" :disabled="isDisabled">{{ textBtnBuscar }}</button>
        <button @click="cancelMethod" class="btn-secondary-volver">{{ getMessage('BTN_VOLVER') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      number: '',
      isDisabled: true
    }
  },
  computed: {
    ...mapGetters('GeneralAR', ['getMessage']),
    textBtnBuscar () {
      return this.emitValue ? 'Confirmar' : this.getMessage(this.primaryBtnText)
    }
  },
  watch: {
    number (val) {
      if (this.emitValue) {
        // para el caso del token de usuario, siempre habilitado, la cant. digitos varia segun financiador
        if (val?.length < 2) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      } else {
        if (val?.length < 6) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      }
    }
  },
  props: {
    enterFunction: {
      type: Function,
      require: false,
      default: () => {}
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    primaryBtnText: {
      type: String,
      required: false,
      default: 'BTN_BUSCAR'
    },
    emitValue: {
      type: Boolean,
      required: false,
      default: false
    },
    routeToGo: {
      type: String,
      required: false,
      default: 'TotemHome'
    }
  },
  methods: {
    acept () {
      if (typeof this.number !== 'undefined' && this.number !== '') {
        if (this.emitValue) {
          this.$emit('numberInput', this.number)
        } else {
          this.enterFunction(this.number)
        }
      }
    },
    numberClick (value) {
      if (!isNaN(value) && this.number.length < 10) {
        this.number = `${this.number}${value}`
      } else if (value === '<') {
        this.number = this.number.substring(0, this.number.length - 1)
      }
    },
    cancelMethod () {
      this.number = ''
      if (this.emitValue) {
        this.$emit('cancel')
      } else {
        this.$router.push({ name: this.routeToGo })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../views/AutoRecepcion/styles.scss';
.buttonpad {
  flex-direction: column;
  display: flex;
  align-items: center;
  width: 422px;
}
.delete-btn {
  width:156px !important;
  border: 2px solid var(--v-primary-base);
  text-align:center;
  font-size:24px
}
.buttonpad button {
  margin: 10px 0px 0px 0px;
  width: 100%;
}
.keypad > div {
  border: 1px solid var(--v-primary-base);
  width: 422px;
  border-radius: 4px;
  margin-top: 10px;
}
.rotate {
  display: none;
  color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  text-align: center;
  width: 400px;
  height: 50px;
  margin-left: -200px;
  margin-top: -25px;
}
.keypadwrapper {
  text-align: center;
  width: 100%;
  color: var(--v-primary-base);
  font-family: "Roboto", sans-serif;
}
.keypadwrapper .numberinput {
  height: 92px;
  width: 422px;
  font-size: 45px;
}
.keypadwrapper .keypad .numberRow {
  width: 100%;
}
.keypadwrapper .keypad #linefour {
  bottom: 10%;
}
.keypadwrapper .keypad #linethree {
  bottom: 30%;
}
.keypadwrapper .keypad #linetwo {
  bottom: 50%;
}
.keypadwrapper .keypad #lineone {
  bottom: 70%;
}
.keypadwrapper .keypad .content {
  display: inline-block;
  margin: 15px 15px;
}
.keypadwrapper .keypad .content div {
  width: 70px;
  height: 70px;
  text-align: center;
  border: 2px solid var(--v-primary-base);
  opacity: 1;
  border-radius: 70px;
  display: inline-block;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.keypadwrapper .keypad .content div span:nth-child(1) {
  display: block;
  font-size: 40px;
  height: 1em;
  margin-top: 0.08em;
}
.keypadwrapper .keypad .content div span:nth-child(2) {
  font-size: 0.9em;
}
.keypadwrapper .keypad .content div:hover {
  background-color: var(--v-primary-base);
  color: white;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.nocircle {
  width: auto !important;
  border: none !important;
  height: auto !important;
}
.btn-secondary-volver {
  /*text*/
  font-family: "Roboto", sans-serif;
  font-size: 28px;
  text-align: center;
  letter-spacing: 0;
  color: var(--v-primary-base);
  /*btn*/
  background-color: #ffffff;
  border: 1px solid var(--v-primary-base);
  border-radius: 4px;
  opacity: 1;
  width: 422px;
  height: 75px;
  margin: 40px;
}
@media all and (max-width: 470px) {
  .content {
    margin: 0 5% !important;
  }
}
@media all and (max-width: 350px) {
  .content {
    margin: 0 2% !important;
  }
}
@media all and (max-height: 470px) {
  #linefour {
    bottom: 2% !important;
  }
  #linethree {
    bottom: 23% !important;
  }
  #linetwo {
    bottom: 43% !important;
  }
  #lineone {
    bottom: 63% !important;
  }
}
</style>
